import { createContext, useContext, useMemo } from 'react';

import { useBookingButtonStatus } from '../hooks/use-booking-button-status';

interface BookingButtonContextType {
	isDisabled: boolean;
}

const BookingButtonContext = createContext<BookingButtonContextType>({
	isDisabled: false
});

export const BookingButtonProvider = ({ 
	children 
}: {
	children: React.ReactNode;
}) => {
	const { isVisible, isDisabled } = useBookingButtonStatus();

	const value = useMemo(() => ({
		isDisabled,
	}), [isDisabled]);

	return (
		<BookingButtonContext.Provider value={value}>
			{isVisible ? children : null}
		</BookingButtonContext.Provider>
	);
};

export const useBookingButtonContext = () => useContext(BookingButtonContext);